:host {

  --_omk-list-item-header-letter-spacing: var(--omk-list-item-header-letter-spacing, var( --omk-font-body-normal-letter-spacing));
  --_omk-list-item-supporting-text-letter-spacing: var(--omk-list-item-supporting-text-letter-spacing, var(--omk-font-body-small-letter-spacing));

  letter-spacing: var(--_omk-list-item-header-letter-spacing);

  --_omk-list-item-primary-header-text-color: var(--omk-list-item-primary-header-text-color, var(--omk-colour-text-primary-resting));
  --_omk-list-item-primary-header-font-family: var(--omk-list-item-primary-header-font-family, var(--omk-font-body-normal-font-family));
  --_omk-list-item-primary-header-font-size: var(--omk-list-item-primary-header-font-size, var(--omk-font-body-normal-font-size));
  --_omk-list-item-primary-header-font-weight: var(--omk-list-item-primary-header-font-weight, var(--omk-font-body-normal-font-weight));
  --_omk-list-item-primary-header-line-height: var(--omk-list-item-primary-header-line-height, var(--omk-font-body-normal-line-height));

  --_omk-list-item-label-text-color: var(--omk-list-item-label-text-color, var(--omk-colour-text-primary-resting));
  --_omk-list-item-label-text-font: var(--omk-list-item-label-text-font, var(--omk-font-body-normal-font-family));
  --_omk-list-item-label-text-line-height: var(--omk-list-item-label-text-line-height, var(--omk-font-body-normal-line-height));
  --_omk-list-item-label-text-size: var(--omk-list-item-label-text-size, var(--omk-font-body-normal-font-size));
  --_omk-list-item-label-text-weight: var(--omk-list-item-label-text-weight, var(--omk-font-body-normal-font-weight));

  --_omk-list-item-supporting-text-color: var(--omk-list-item-supporting-text-color, var(--omk-colour-text-secondary-resting));
  --_omk-list-item-supporting-text-font: var(--omk-list-item-supporting-text-font, var(--omk-font-body-small-font-family));
  --_omk-list-item-supporting-text-line-height: var(--omk-list-item-supporting-text-line-height, var(--omk-font-body-small-line-height));
  --_omk-list-item-supporting-text-size: var(--omk-list-item-supporting-text-size, var(--omk-font-body-small-font-size));
  --_omk-list-item-supporting-text-weight: var(--omk-list-item-supporting-text-weight, var(--omk-font-body-small-font-weight));

  --_omk-list-item-top-space: var(--omk-list-item-top-space, var(--omk-dimension-spacing-small));
  --_omk-list-item-bottom-space: var(--omk-list-item-bottom-space, var(--omk-dimension-spacing-small));
  --_omk-list-item-leading-space: var(--omk-list-item-leading-space, var(--omk-dimension-spacing-small));
  --_omk-list-item-trailing-space: var(--omk-list-item-trailing-space, var(--omk-dimension-spacing-small));
  --_omk-list-item-leading-icon-size: var(--omk-list-item-leading-icon-size, 24px);
  --_omk-list-item-trailing-icon-size: var(--omk-list-item-trailing-icon-size, 24px);
  --_omk-list-item-leading-icon-color: var(--omk-list-item-leading-icon-color, var(--omk-colour-icon-primary-resting));
  --_omk-list-item-trailing-icon-color: var(--omk-list-item-trailing-icon-color, var(--omk-colour-icon-primary-resting));

  --_omk-list-item-secondary-label-text-font: (--omk-list-item-secondary-label-text-font, var(--omk-font-body-small-font-family));
  --_omk-list-item-secondary-label-text-line-height: var(--omk-list-item-secondary-label-text-line-height, var(--omk-font-body-small-line-height));
  --_omk-list-item-secondary-label-text-size: var(--omk-list-item-secondary-label-text-size, var(--omk-font-body-small-font-size));
  --_omk-list-item-secondary-label-text-weight: var(--omk-list-item-secondary-label-text-weight, var(--omk-font-body-small-font-weight));

  --_omk-list-item-secondary-supporting-text-font: var(--omk-list-item-secondary-supporting-text-font, var(--omk-font-body-xsmall-font-family));
  --_omk-list-item-secondary-supporting-text-line-height: var(--omk-list-item-secondary-supporting-text-line-height, var(--omk-font-body-xsmall-line-height));
  --_omk-list-item-secondary-supporting-text-size: var(--omk-list-item-secondary-supporting-text-size, var(--omk-font-body-xsmall-font-size));
  --_omk-list-item-secondary-supporting-text-weight: var(--omk-list-item-secondary-supporting-text-weight, var(--omk-font-body-xsmall-font-weight));

  --md-list-item-label-text-color: var(--_omk-list-item-label-text-color);
  --md-list-item-label-text-font: var(--_omk-list-item-label-text-font);
  --md-list-item-label-text-line-height: var(--_omk-list-item-label-text-line-height);
  --md-list-item-label-text-size: var(--_omk-list-item-label-text-size);
  --md-list-item-label-text-weight: var(--_omk-list-item-label-text-weight);

  --md-list-item-supporting-text-color: var(--_omk-list-item-supporting-text-color);
  --md-list-item-supporting-text-font: var(--_omk-list-item-supporting-text-font);
  --md-list-item-supporting-text-line-height: var(--_omk-list-item-supporting-text-line-height);
  --md-list-item-supporting-text-size: var(--_omk-list-item-supporting-text-size);
  --md-list-item-supporting-text-weight: var(--_omk-list-item-supporting-text-weight);

  --md-list-item-top-space: var(--_omk-list-item-top-space);
  --md-list-item-bottom-space: var(--_omk-list-item-bottom-space);
  --md-list-item-leading-space: var(--_omk-list-item-leading-space);
  --md-list-item-trailing-space: var(--_omk-list-item-bottom-space);
  --md-list-item-leading-icon-size: var(--_omk-list-item-leading-icon-size);
  --md-list-item-trailing-icon-size: var(--_omk-list-item-trailing-icon-size);
  --md-list-item-leading-icon-color: var(--_omk-list-item-leading-icon-color);
  --md-list-item-trailing-icon-color: var(--_omk-list-item-trailing-icon-color);
}

md-list-item.hasPrimaryHeader {
  --md-list-item-label-text-font: var(--_omk-list-item-secondary-label-text-font);
  --md-list-item-label-text-line-height: var(--_omk-list-item-secondary-label-text-line-height);
  --md-list-item-label-text-size: var(--_omk-list-item-secondary-label-text-size);
  --md-list-item-label-text-weight: var(--_omk-list-item-secondary-label-text-weight);

  --md-list-item-supporting-text-font: var(--_omk-list-item-secondary-supporting-text-font);
  --md-list-item-supporting-text-line-height: var(--_omk-list-item-secondary-supporting-text-line-height);
  --md-list-item-supporting-text-size: var(--_omk-list-item-secondary-supporting-text-size);
  --md-list-item-supporting-text-weight: var(--_omk-list-item-secondary-supporting-text-weight);
}

.primary-header {
  color: var(--_omk-list-item-primary-header-text-color);
  font-family: var(--_omk-list-item-primary-header-font-family);
  font-size: var(--_omk-list-item-primary-header-font-size);
  font-weight: var(--_omk-list-item-primary-header-font-weight);
  line-height: var(--_omk-list-item-primary-header-line-height);
}

slot[name='supporting-text']::slotted(*) {
  letter-spacing: var(--_omk-list-item-supporting-text-letter-spacing);
}

:host([redirected-clicks-include-other-slot][redirect-clicks-to-slot='start']) md-list-item > slot:nth-child(2) {
  cursor: pointer;
}

:host([redirected-clicks-include-other-slot][redirect-clicks-to-slot='end']) md-list-item > slot:nth-child(1) {
  cursor: pointer;
}

slot[name='supporting-text']:not([redirect-clicks-to-slot='none'])::slotted(*) {
  cursor: pointer;
}

slot[name='headline']:not([redirect-clicks-to-slot='none'])::slotted(*) {
  cursor: pointer;
}
